module.exports = __webpack_public_path__ + "img/60-image-1@2x.bd60da21.png";